import React from 'react';
import {
  SectionContainer,
  HeroH1,
  HeroP,
  HeroH2,
  Root,
  SocialIconWrapper,
  IconsWrapper,
  Tags,
  Tag,
  ProfileImg,
  Flex,
} from './HeroElements';
import { FaGithub, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { SiGmail } from 'react-icons/si';
import architJainImg from '../../images/archit-jain.png';

const HeroSection = () => {
  return (
    <Root>
      <SectionContainer>
        <Flex>
          <ProfileImg
            src={architJainImg}
            alt="Archit Jain"
            width={600}
            height={600}
          />
          <div>
            <HeroH1>Archit Jain</HeroH1>
            <HeroH2>Robotics Engineer</HeroH2>
            <Tags style={{ marginTop: '12px' }}>
              <Tag>Robotics Enthusiast </Tag>
              <Tag>Robot Operating System (ROS) </Tag>
              <Tag>Mobile Robotics </Tag>
              <Tag>Robotic Arm </Tag>
              <Tag>Drone </Tag>
              <Tag>Design & Manufacturing </Tag>
              <Tag>Product Design </Tag>
              <Tag>Computer Vision </Tag>
            </Tags>
          </div>
        </Flex>
        <HeroP style={{ marginTop: '24px' }}>
          Self-motivated and hardworking graduate with a great experience in
          product development and motivated towards research oriented work. Have
          a strong work ethic, ability to handle multiple projects at once, and
          a yearning to never stop learning. Have relevant industrial experience
          in Robotics, 3D printing, Product Design, Robot Operating System (ROS1
          and ROS2), SLAM, Sensor Fusion, Drones, and Manufacturing.
        </HeroP>

        <IconsWrapper>
          <SocialIconWrapper
            as="a"
            href="mailto:arrchit.jain@gmail.com"
            target="_blank"
          >
            <SiGmail />
          </SocialIconWrapper>
          <SocialIconWrapper
            as="a"
            href="https://linkedin.com/in/archit-jain19"
            target="_blank"
          >
            <FaLinkedin />
          </SocialIconWrapper>
          <SocialIconWrapper
            as="a"
            href="https://github.com/architjain19"
            target="_blank"
          >
            <FaGithub />
          </SocialIconWrapper>
          <SocialIconWrapper
            as="a"
            href="https://youtube.com/playlist?list=PLbmLO3yVoGJ0m8Gyiigr6jaN6WQH5rKII&si=i1aCkb9frX62v73K"
            target="_blank"
          >
            <FaYoutube />
          </SocialIconWrapper>
        </IconsWrapper>
      </SectionContainer>
    </Root>
  );
};

export default HeroSection;
